export type IconName =
  | 'menuAjuda'
  | 'menuConfiguracoes'
  | 'menuContexto'
  | 'menuGerenciarUsuario'
  | 'menuHome'
  | 'menuLoja'
  | 'menuObras'
  | 'menuPlotagem'
  | 'menuSolicitacoes'
  | 'disciplinaArquitetura'
  | 'disciplinaEstrutura'
  | 'disciplinaMecanica'
  | 'disciplinaFundacao'
  | 'disciplinaEletrica'
  | 'disciplinaHidrossanitaria'
  | 'disciplinaIncendio'
  | 'disciplinaAr'
  | 'arquivo2d'
  | 'arquivo3d'
  | 'arquivoPdf'
  | 'arquivoTxt'
  | 'arquivoImg'
  | 'arquivoExcel'
  | 'viewerDrive'
  | 'viewerDropbox'
  | 'viewerForge'
  | 'viewerOffice'
  | 'notificacoes'
  | 'adicionar'
  | 'subtrair'
  | 'cancelar'
  | 'adicionarUsuario'
  | 'conviteAceito'
  | 'editarImg'
  | 'upload'
  | 'download'
  | 'editar'
  | 'trocarStatus'
  | 'solicitarPlotagem'
  | 'informacao'
  | 'excluir'
  | 'filtrar'
  | 'arquivar'
  | 'buscar'
  | 'sair'
  | 'receber'
  | 'informacaoAdicional'
  | 'localizacao'
  | 'confirmar'
  | 'avancar'
  | 'retroceder'
  | 'expandir'
  | 'bolinhaSelecionada'
  | 'bolinhaNaoSelecionada'
  | 'collapse'
  | 'confirmacao'
  | 'error'
  | 'checkedSenha'
  | 'errorSenha'
  | 'cadeado'
  | 'arroba'
  | 'estrela'
  | 'visualizar'
  | 'diciplinaAr'
  | 'voltar'
  | 'mover'
  | 'setaOrdenarAsc'
  | 'setaOrdenarDesc'
  | 'semConexao'
  | 'viewerOnedrive'
  | 'atualizar'
  | 'aviso'
  | 'crown'
  | 'estrelaVazia'
  | 'moreActions'
  | 'email'
  | 'link'
  | 'excluirUser'
  | 'arquivo'
  | 'activities'
  | 'obsoleteArchive'
  | 'viewPoint'
  | 'avancarDuplo'
  | 'cadeadoFechado'
  | 'ccube'
  | 'cube'
  | 'docEye'
  | 'filePile'
  | 'camera'
  | 'maleta'
  | 'notVisualizar'
  | 'pranchasItens'
  | 'viewpointsItens'
  | 'unbind'
  | 'listList'
  | 'listKanban'
  | 'listDetailVision'
  | 'globe'
  | 'flag'
  | 'calendar'
  | 'kanbanCollapse'
  | 'adicionarAlt'
  | 'squareChat'
  | 'megaphone'
  | 'person'
  | 'criativy'
  | 'relogio'
  | 'TopLeft'
  | 'TopRight'
  | 'TopCenter'
  | 'CenterLeft'
  | 'CenterRight'
  | 'CenterCenter'
  | 'BottomLeft'
  | 'BottomRight'
  | 'BottomCenter'
  | 'alerta'
  | 'adicionarPasta'
  | 'share'
  | 'copiar'
  | 'eraseFilter'
  | 'emptyExcluir'
  | 'galery'
  | 'carousel'
  | 'openNewTab'
  | 'panels'
  | 'pin'
  | 'coordly'
  | 'customTag'
  | 'unpin'
  | 'rightArrow'
  | 'input'
  | 'history'
  | 'paperclip'
  | 'bolt'
  | 'phases'
  | 'storage'
  | 'team'
  | 'archive'
  | 'key'
  | 'abnt'
  | 'checkedOutline'
  | 'palette'
  | 'qrCode'
  | 'smile'
  | 'downArrow'
  | 'play'
  | 'doubleCheck'
  | 'readNotification'
  | 'pencil'
  | 'eyeCheck'
  | 'adjustments'
  | 'bell'
  | 'arrowExpand'
  | 'panels2'
  | 'lessexpand'
  | 'doubleChat'
  | 'reportMail'
  | 'newEdit'
  | 'eyeX'
  | 'ThumbsDown'
  | 'ThumbsUp'
  | 'assistentes'
  | 'bold'
  | 'italic'
  | 'underline'
  | 'lineThrough'
  | 'layers'
  | 'switchBg'
  | 'move'
  | 'measureDistance'
  | 'measureArea'
  | 'measureArc'
  | 'measure'
  | 'measureAngle'
  | 'zoomToExtent'
  | 'zoomToBox'
  | 'pointStyle'
  | 'whatsapp'
  | 'borderCorners'
  | 'paperModel'
  | 'phone'
  | 'airConditioning'
  | 'alertTriangle'
  | 'armchair'
  | 'ballFootball'
  | 'barbell'
  | 'barrierBlock'
  | 'bathtub'
  | 'biohazard'
  | 'brickWall'
  | 'brush'
  | 'buildingBroadcastTower'
  | 'buildingFactory'
  | 'buildingScryscraper'
  | 'buildingWarehouse'
  | 'bulb'
  | 'calculator'
  | 'camera2'
  | 'car'
  | 'carBattery'
  | 'checkupList'
  | 'cloudRain'
  | 'coffee'
  | 'coinsMoney'
  | 'colorSwatch'
  | 'crane'
  | 'dog'
  | 'door'
  | 'elevator'
  | 'faceId'
  | 'fence'
  | 'fingerprint'
  | 'fireHydrant'
  | 'flower'
  | 'geometry'
  | 'graduationCap'
  | 'hammer'
  | 'headset'
  | 'hotelService'
  | 'idBadge'
  | 'jacket'
  | 'key2'
  | 'lamp'
  | 'lockAccess'
  | 'map'
  | 'mapPin'
  | 'mapSearch'
  | 'package'
  | 'paint'
  | 'paw'
  | 'plant'
  | 'plug'
  | 'plugConnect'
  | 'pool'
  | 'propeller'
  | 'radioactive'
  | 'recycle'
  | 'road'
  | 'snowflake'
  | 'solarPanel'
  | 'solarPanel2'
  | 'stairs'
  | 'temperature'
  | 'temperatureMinus'
  | 'temperaturePlus'
  | 'tools'
  | 'trafficeCone'
  | 'trees'
  | 'truckDelivery'
  | 'truckLoading'
  | 'umbrella'
  | 'urgent'
  | 'wind'
  | 'wreckingBall'
  | 'section'
  | 'human'
  | 'explode'
  | 'arrowsVertical'
  | '360'
  | 'medicao'
  | 'autodesk'
  | 'filterNot'
  | 'ortogonal'
  | 'distance'
  | 'perspectiva'
  | 'enquadrarModelo'
  | 'enquadrarSelecao'
  | 'eraser'
  | 'area'
  | 'corteLateral'
  | 'corteHorizontal'
  | 'corteFrontal';

export const iconClasses = {
  menuAjuda: 'icon-menu-ajuda',
  menuConfiguracoes: 'icon-menu-configuracoes',
  menuContexto: 'icon-menu-contexto',
  menuGerenciarUsuario: 'icon-menu-gerenciar-usuario',
  menuHome: 'icon-menu-home',
  menuLoja: 'icon-menu-loja',
  menuObras: 'icon-menu-obras',
  menuPlotagem: 'icon-menu-plotagem',
  menuSolicitacoes: 'icon-menu-solicitacoes',
  disciplinaArquitetura: 'icon-disciplina-arquitetura',
  disciplinaEstrutura: 'icon-disciplina-estrutura',
  disciplinaMecanica: 'icon-disciplina-mecanica',
  disciplinaFundacao: 'icon-disciplina-fundacoes',
  disciplinaEletrica: 'icon-disciplina-eletrica',
  disciplinaHidrossanitaria: 'icon-disciplina-hidrossanitarias',
  disciplinaIncendio: 'icon-disciplina-incendio',
  disciplinaAr: 'icon-disciplina-ar',
  arquivo2d: 'icon-arquivo-2d',
  arquivo3d: 'icon-arquivo-3d',
  arquivoPdf: 'icon-arquivo-pdf',
  arquivoTxt: 'icon-arquivo-texto',
  arquivoImg: 'icon-arquivo-img',
  arquivoExcel: 'icon-arquivo-excel',
  viewerDrive: 'icon-viewer-drive',
  viewerDropbox: 'icon-viewer-dropbox',
  viewerForge: 'icon-viewer-forge',
  viewerOffice: 'icon-viewer-office',
  notificacoes: 'icon-notificacoes',
  adicionar: 'icon-adicionar',
  subtrair: 'icon-subtrair',
  cancelar: 'icon-cancelar',
  adicionarUsuario: 'icon-adicionar-usuario',
  conviteAceito: 'icon-notificacao-convite-aceito',
  editarImg: 'icon-editar-imagem',
  upload: 'icon-upload',
  download: 'icon-download',
  editar: 'icon-editar',
  trocarStatus: 'icon-trocar-status',
  solicitarPlotagem: 'icon-solicitar-plotagem',
  informacao: 'icon-informacao',
  excluir: 'icon-lixeira',
  filtrar: 'icon-filtrar',
  arquivar: 'icon-arquivar',
  buscar: 'icon-pesquisar',
  sair: 'icon-sair',
  receber: 'icon-receber',
  informacaoAdicional: 'icon-informacao-adicional',
  localizacao: 'icon-localizacao',
  confirmar: 'icon-confirmar',
  avancar: 'icon-avancar',
  retroceder: 'icon-retroceder',
  expandir: 'icon-expandir',
  bolinhaSelecionada: 'icon-bolinhaSelecionada',
  bolinhaNaoSelecionada: 'icon-bolinhaNaoSelecionada',
  collapse: 'icon-collapse',
  confirmacao: 'icon-confirmacao',
  error: 'icon-error',
  checkedSenha: 'icon-checkedSenha',
  errorSenha: 'icon-erroSenha',
  arroba: 'icon-arroba',
  cadeado: 'icon-cadeado',
  estrela: 'icon-estrela',
  visualizar: 'icon-visualizar',
  diciplinaAr: 'icon-disciplina-ar',
  voltar: 'icon-voltar',
  mover: 'icon-mover',
  setaOrdenarAsc: 'icon-seta-ordenar-desc',
  setaOrdenarDesc: 'icon-seta-ordenar-asc',
  semConexao: 'icon-sem-conexao',
  viewerOnedrive: 'icon-viewer-onedrive',
  atualizar: 'icon-atualizar',
  aviso: 'icon-aviso',
  crown: 'icon-crow-cta',
  estrelaVazia: 'icon-estrela-vazia',
  moreActions: 'icon-more-actions',
  link: 'icon-icon-link',
  excluirUser: 'icon-icon-excluir-user',
  arquivo: 'icon-arquivo-doc',
  activities: 'icon-activities',
  obsoleteArchive: 'icon-obsolete-archive',
  viewPoint: 'icon-viewpoint',
  avancarDuplo: 'icon-avancar-duplo',
  cadeadoFechado: 'icon-cadeado-fechado',
  ccube: 'icon-ccube',
  cube: 'icon-cube',
  docEye: 'icon-doc-eye',
  filePile: 'icon-pile-file',
  camera: 'icon-camera',
  maleta: 'icon-maleta',
  notVisualizar: 'icon-not-visualizar',
  pranchasItens: 'icon-pranchas-itens',
  viewpointsItens: 'icon-viewpoints-itens',
  unbind: 'icon-unbind',
  listList: 'icon-list-list',
  listKanban: 'icon-list-kanban',
  listDetailVision: 'icon-list-detailVision',
  globe: 'icon-globe',
  flag: 'icon-flag',
  calendar: 'icon-calendar',
  kanbanCollapse: 'icon-kanban-collapse',
  adicionarAlt: 'icon-adicionar-alt',
  squareChat: 'icon-square-chat',
  megaphone: 'icon-megaphone',
  person: 'icon-person',
  criativy: 'icon-criativy',
  relogio: 'icon-relogio',
  TopLeft: 'icon-top-left',
  TopRight: 'icon-top-right',
  TopCenter: 'icon-top-center',
  CenterLeft: 'icon-center-left',
  CenterRight: 'icon-center-right',
  CenterCenter: 'icon-center',
  BottomLeft: 'icon-bottom-left',
  BottomRight: 'icon-bottom-right',
  BottomCenter: 'icon-bottom-center',
  alerta: 'icon-alert',
  adicionarPasta: 'icon-folder-add',
  share: 'icon-share',
  copiar: 'icon-copy',
  eraseFilter: 'icon-erase-filter',
  emptyExcluir: 'icon-lixeira-vazia',
  galery: 'icon-galery',
  carousel: 'icon-carousel',
  openNewTab: 'icon-open-new-tab',
  panels: 'icon-panels',
  pin: 'icon-pin',
  coordly: 'icon-coordly',
  customTag: 'icon-custom-tag',
  unpin: 'icon-unpin',
  rightArrow: 'icon-right-arrow',
  input: 'icon-input',
  history: 'icon-history',
  paperclip: 'icon-paperclip',
  bolt: 'icon-bolt',
  phases: 'icon-phases',
  storage: 'icon-storage',
  team: 'icon-team',
  archive: 'icon-archive',
  key: 'icon-key',
  abnt: 'icon-abnt',
  checkedOutline: 'icon-checked-outline',
  palette: 'icon-palette',
  qrCode: 'icon-qr-code',
  smile: 'icon-smile',
  downArrow: 'icon-down-arrow',
  play: 'icon-play',
  doubleCheck: 'icon-double-check',
  readNotification: 'icon-read-notification',
  pencil: 'icon-pencil',
  doubleChat: 'icon-double-chat',
  eyeCheck: 'icon-eye-check',
  adjustments: 'icon-adjustments',
  bell: 'icon-bell',
  email: 'icon-email',
  arrowExpand: 'icon-arrow-expand',
  panels2: 'icon-panels2',
  lessexpand: 'icon-lessexpand',
  reportMail: 'icon-report-mail',
  eyeX: 'icon-eye-x',
  newEdit: 'icon-new-edit',
  ThumbsDown: 'icon-Thumbs-Down',
  ThumbsUp: 'icon-thumbs-up',
  assistentes: 'icon-assistentes',
  bold: 'icon-bold',
  italic: 'icon-italic',
  underline: 'icon-underline',
  lineThrough: 'icon-line-through',
  layers: 'icon-layers',
  switchBg: 'icon-switch-bg',
  move: 'icon-move',
  measureDistance: 'icon-measureDistance',
  measureArea: 'icon-measureArea',
  measureArc: 'icon-measureArc',
  measure: 'icon-measure',
  measureAngle: 'icon-measureAngle',
  zoomToExtent: 'icon-zoomToExtent',
  zoomToBox: 'icon-zoomToBox',
  pointStyle: 'icon-point-style',
  whatsapp: 'icon-whatsapp',
  borderCorners: 'icon-border-corners',
  paperModel: 'icon-paper-model',
  phone: 'icon-phone',
  airConditioning: 'icon-air-conditioning',
  alertTriangle: 'icon-alert-triangle',
  armchair: 'icon-armchair',
  ballFootball: 'icon-ball-football',
  barbell: 'icon-barbell',
  barrierBlock: 'icon-barrier-block',
  bathtub: 'icon-bathtub',
  biohazard: 'icon-biohazard',
  brickWall: 'icon-brick-wall',
  brush: 'icon-brush',
  buildingBroadcastTower: 'icon-building-broadcast-tower',
  buildingFactory: 'icon-building-factory',
  buildingScryscraper: 'icon-building-scryscraper',
  buildingWarehouse: 'icon-building-warehouse',
  bulb: 'icon-bulb',
  calculator: 'icon-calculator',
  camera2: 'icon-camera-2',
  car: 'icon-car',
  carBattery: 'icon-car-battery',
  checkupList: 'icon-checkup-list',
  cloudRain: 'icon-cloud-rain',
  coffee: 'icon-coffee',
  coinsMoney: 'icon-coins-money',
  colorSwatch: 'icon-color-swatch',
  crane: 'icon-crane',
  dog: 'icon-dog',
  door: 'icon-door',
  elevator: 'icon-elevator',
  faceId: 'icon-face-id',
  fence: 'icon-fence',
  fingerprint: 'icon-fingerprint',
  fireHydrant: 'icon-fire-hydrant',
  flower: 'icon-flower',
  geometry: 'icon-geometry',
  graduationCap: 'icon-graduation-cap',
  hammer: 'icon-hammer',
  headset: 'icon-headset',
  hotelService: 'icon-hotel-service',
  idBadge: 'icon-id-badge',
  jacket: 'icon-jacket',
  key2: 'icon-key-2',
  lamp: 'icon-lamp',
  lockAccess: 'icon-lock-access',
  map: 'icon-map',
  mapPin: 'icon-map-pin',
  mapSearch: 'icon-map-search',
  package: 'icon-package',
  paint: 'icon-paint',
  paw: 'icon-paw',
  plant: 'icon-plant',
  plug: 'icon-plug',
  plugConnect: 'icon-plug-connect',
  pool: 'icon-pool',
  propeller: 'icon-propeller',
  radioactive: 'icon-radioactive',
  recycle: 'icon-recycle',
  road: 'icon-road',
  snowflake: 'icon-snowflake',
  solarPanel: 'icon-solar-panel',
  solarPanel2: 'icon-solar-panel-2',
  stairs: 'icon-stairs',
  temperature: 'icon-temperature',
  temperatureMinus: 'icon-temperature-minus',
  temperaturePlus: 'icon-temperature-plus',
  tools: 'icon-tools',
  trafficeCone: 'icon-traffice-cone',
  trees: 'icon-trees',
  truckDelivery: 'icon-truck-delivery',
  truckLoading: 'icon-truck-loading',
  umbrella: 'icon-umbrella',
  urgent: 'icon-urgent',
  wind: 'icon-wind',
  wreckingBall: 'icon-wrecking-ball',
  section: 'icon-section',
  human: 'icon-human',
  explode: 'icon-explode',
  arrowsVertical: 'icon-arrows-vertical',
  '360': 'icon-360',
  medicao: 'icon-medicao',
  autodesk: 'icon-autodesk',
  filterNot: 'icon-filter-not',
  ortogonal: 'icon-ortogonal',
  distance: 'icon-distance',
  perspectiva: 'icon-perspectiva',
  enquadrarModelo: 'icon-enquadrar-modelo',
  enquadrarSelecao: 'icon-enquadrar-selecao',
  eraser: 'icon-eraser',
  area: 'icon-area',
  corteLateral: 'icon-corte-lateral',
  corteHorizontal: 'icon-corte-horizontal',
  corteFrontal: 'icon-corte-frontal'
};
